import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) navigate("/admin");
    else setError(res.error);
  };

  return (
    <div className="mx-auto max-w-md px-4 py-24">
      <div className="bg-card border border-border p-8">
        <ShieldAlert className="h-7 w-7 text-accent" />
        <h1 className="mt-4 font-serif text-3xl font-bold text-foreground">Archivist Access</h1>
        <p className="mt-1 text-sm text-muted-foreground">Sign in to manage the pyramid catalogue.</p>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">Email</label>
            <input
              data-testid="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="mt-1 w-full bg-background border border-border px-4 py-3 text-sm focus:outline-none focus:border-accent"
            />
          </div>
          <div>
            <label className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">Password</label>
            <input
              data-testid="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="mt-1 w-full bg-background border border-border px-4 py-3 text-sm focus:outline-none focus:border-accent"
            />
          </div>
          {error && <p data-testid="login-error" className="font-mono text-xs text-destructive">{error}</p>}
          <button
            data-testid="login-submit"
            type="submit"
            disabled={busy}
            className="w-full bg-accent text-accent-foreground font-mono text-xs uppercase tracking-widest py-3.5 hover:bg-accent/90 transition-colors disabled:opacity-60"
          >
            {busy ? "Authenticating…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
